export default {
	data() {
		const breakTypes = [
			{ id: 'local', name: () => this.$tCaption('Local'), icon: 'fas fa-map-marker-alt' },
			{ id: 'network', name: () => this.$tCaption('Network'), icon: 'fas fa-project-diagram' },
		];
		return {
			breakTypes,
			breakPopupVisible: false,
			networkShowCues: []
		}
	},
	computed: {
		isNetworkStudio() {
			return this.opts?.networkStudio;
		},
		networkStudioInsertionContextMenu() {
			return [
				...this.breakTypes.map(f => ({
					id: `break_${f.id}`,
					name: () => f.name,
					icon: (track) => `${f.icon} ${track?.breakType === f.id ? 'tracker-active-icon' : ''}`,
					hidden: (track) => !track.breakType,
					group: 'breakType',
					isNetworkStudioAction: true
				})),
				...this.networkShowCues.map(f => ({
					id: `networkCue_${f.Oid}`,
					name: () => f.Name,
					icon: (track) => `fas fa-bookmark ${track?.insertion?.NetworkNetCue?.Oid === f.Oid ? 'tracker-active-icon' : ''}`,
					group: 'networkCue',
					isNetworkStudioAction: true
				})),
				{
					id: `networkCueClear`,
					name: () => this.$tCaption('Clear'),
					icon: () => 'fas fa-times',
					group: 'networkCue',
					hidden: (track) => !track?.insertion?.NetworkNetCue,
					isNetworkStudioAction: true
				}
			]
		},
		networkStudioInsertionContextMenuGroups() {
			return [
				{
					id: 'networkCue',
					name: () => this.$tCaption('Net cue'),
					icon: () => 'fas fa-bookmark'
				},
				{
					id: 'breakType',
					name: () => this.$tCaption('Break type'),
					icon: () => 'fas fa-pause'
				},
			]
		}
	},
	mounted() {
		if (this.isNetworkStudio) {
			this.loadNetworkShowCues();
		}
	},
	methods: {
		saveBreakInsertion() {
			this.isLoading++;
			if (__DEBUG__)
				console.debug('Create insertion');
			this.$Data.createUpdatePureInsertion(this.editingTrack.insertion).then(r => {
				if (__DEBUG__)
					console.debug('Break insertion cretead', { r });
				if (r.Success) {
					this.processAddTrack(this.getTrackFromInsertion(r.Data));
				} else {
					this.$notifyError(r.ErrorMessage);
				}
				this.isLoading--;
				return null;
			}).catch(() => this.isLoading--);
		},
		loadNetworkShowCues() {
			this.$Data.getNetworkShowCues(0, 999).then(r => this.networkShowCues = r?.Results || []);
		},
		exectureNetworkStudioTrackAction(actionId, track, actionItem, aggregatedTrack) {
			if (actionId?.indexOf('break_') > -1) {
				let breakType = this.breakTypes.findIndex(f => f.id === actionId.replace('break_', ''));
				if (breakType > -1) {
					track.insertion.BreakType = breakType;
					track.__saveInsertion(actionId);
				}
				return;
			}

			if (actionId?.indexOf('networkCue_') > -1) {
				let networkCue = this.networkShowCues.find(f => f.Oid === actionId.replace('networkCue_', ''));
				if (networkCue) {
					track.insertion.NetworkNetCue = networkCue;
					track.__saveInsertion(actionId);
				}
				return;
			}

			if (actionId === 'networkCueClear') {
				track.insertion.NetworkNetCue = null;
				track.__saveInsertion(actionId);
			}
		}
	}
};
